import { HeaderMiniCartDropMenuV2 } from '@/components/content/Header/parts/MiniCartDropMenuV2';
import { headerItemStackSX } from '@/components/content/Header/styles/itemStack';
import {
	headerMiniCartContainerSX,
	iconCountCartSX,
	numberCountCartSX,
} from '@/components/content/Header/styles/miniCart/container';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

import {Stack, Typography } from '@mui/material';
import React, { FC, MouseEventHandler } from 'react';

type Props = {
	open: boolean;
	count: number;
	handleToolTip: (action: string) => () => void;
	onMouseEnter: MouseEventHandler<HTMLDivElement>;
	onDeleteCart: () => Promise<void>;
};

export const HeaderMiniCartDesktopV2: FC<Props> = ({
	open,
	count,
	handleToolTip,
	onMouseEnter,
	onDeleteCart,
}) => (
	<React.Fragment>
		<Stack sx={headerMiniCartContainerSX}>
				<Stack alignItems="center" onClick={onMouseEnter} sx={headerItemStackSX}>
					<Stack sx={{ alignItems: 'center', paddingTop: '0px' }}>
						{count > 0 ? (
							<Typography sx={numberCountCartSX({ isMobile: false })}>{count}</Typography>
						) : null}
						<ShoppingCartIcon sx={iconCountCartSX({ isMobile: false, isItemsCount: count > 0 })} />
					</Stack>
				</Stack>
		</Stack>
		<HeaderMiniCartDropMenuV2 open={open} onClose={handleToolTip('close')} onDeleteCart={onDeleteCart} />
	</React.Fragment>
);
